import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  AdobeRequest,
  AdobeResponse,
  REGISTRATION_CONFIG,
  RegistrationConfig,
} from '@us-registration/util-models';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdobeCampaignService {
  constructor(
    @Inject(REGISTRATION_CONFIG)
    protected readonly registrationConfig: RegistrationConfig,
    protected readonly httpClient: HttpClient
  ) {}

  sendToAdobeCampaign(adobeRequest: AdobeRequest): Observable<AdobeResponse> {
    return this.httpClient
      .post<AdobeResponse>(
        `${this.registrationConfig.adobeCampaignApi}`,
        adobeRequest
      )
      .pipe(map((response: AdobeResponse) => response));
  }
}
